export default __webpack_public_path__ + "static/media/62aa281634802c9abd5775ee3c5b16661579635664137.12a4ce95.webp";